import type { PermissionString } from '../../../../types/permissions';
import type { EvvColumnField } from '../../../../dtos/evv/reconciliation.dto';
import { isApiError } from '../../../../dtos/common/api.dto';

/** PRD §3.2: read = Admin, Coordinator, Billing, Read-only; write = Admin, Coordinator; override = Admin. */
export const EVV_READ = 'evv:reconciliation:read' as PermissionString;
export const EVV_WRITE = 'evv:reconciliation:write' as PermissionString;
export const EVV_OVERRIDE = 'evv:override' as PermissionString;

export const OVERRIDE_REASON_MIN = 10;
export const OVERRIDE_REASON_MAX = 500;
export const HHAX_URL = 'https://app.hhaexchange.com/';

/** Columns a coordinator can map when HHAX renames one (EVV-16). Required ones first. */
export const COLUMN_FIELDS: Array<{ field: EvvColumnField; label: string; required?: boolean }> = [
  { field: 'agencyTaxId', label: 'Agency Tax ID', required: true },
  { field: 'serviceDate', label: 'Schedule Date', required: true },
  { field: 'clockIn', label: 'Visit Start', required: true },
  { field: 'clockOut', label: 'Visit End', required: true },
  { field: 'serviceCode', label: 'Billing Service Code', required: true },
  { field: 'problem', label: 'Problem', required: true },
  { field: 'medicaidId', label: 'User Field 1 (Payer Patient ID / Medicaid ID)' },
  { field: 'hhaxPatientId', label: 'Patient ID (HHAX)' },
  { field: 'thirdPartyScheduleId', label: '3rd Party Schedule ID' },
  { field: 'thirdPartyCaregiverCode', label: '3rd Party Caregiver Code' },
];

export function errorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}

export function errorCode(error: unknown): string | undefined {
  return isApiError(error) ? error.domainCode : undefined;
}

export function errorDetails(error: unknown): Record<string, unknown> | undefined {
  return isApiError(error) ? error.details : undefined;
}

export function formatTime(iso?: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

export function formatDateTime(iso?: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleString();
}

export function formatMinutes(minutes?: number | null): string {
  if (minutes === undefined || minutes === null) return '—';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${minutes} min (${h}h ${String(m).padStart(2, '0')}m)`;
}
